import { useState, useEffect } from "react";
import { NumberStateAction } from "../../helpers/functions/types";

type UseCounterReturn = {
  isCounting: boolean;
  counter: number;
  setCounter: NumberStateAction;
};

export const useCounter = (starter: number): UseCounterReturn => {
  const [counter, setCounter] = useState(starter);

  useEffect(() => {
    const interval = setTimeout(() => {
      if (counter <= 0) return;

      setCounter(counter - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [counter]);

  return { isCounting: counter > 0, counter, setCounter };
};
